export default {
  "language": "ht",
  "message":
    {
      "title": "Melanj revni lojman bonis kalkilatris",
      "zoningDistrict": "Chwazi dekoupaj an zòn distri",
      "affordabilityLevel": "Chwazi yon nivo aksesibilite",
      "allThatApply": "Chwazi tout sa ki aplike.",
      "springGardenS": "Èske pwojè a ki sitiye nan sid Spring Jaden Street",
      "yes": "Wi",
      "no": "Pa",
      "affordability": {
        "lowIncome": "Revni ki ba",
        "moderateIncome": "Revni modere",
      },
      "lotAreaSqft": "Antre nan anpil zòn nan pye kare",
      "buildingHeight": "Antre nan wotè bilding lan",
      "totalUnits": "Kantite inite yo pwopoze nan pwojè a:",
      "unitsEarnedLow": "Inite Lòt Touche (Revni Ba):",
      "unitsEarnedMod": "Inite Lòt Touche (Revni Modere):",
      "greenRoofBonus": "Nimewo nan Inite Bonis Do-Kay Green:",
      "modIncomePayment": "Peman Estimasyon Revni Modere:",
      "lowIncomePayment": "Low Revni Estimasyon Peman:",
      "requiredAffordableUnits": "Obligatwa MIHB Inite Abòdab: ",
      "requiredMinAffordableUnits": "Egzije/MIN Inite Abòdab:",
      "totalRequiredAffordabilityUnits": "Total Inite Abòdab Obligatwa:",
      "additionalFar": "Lòt FAR Touche:",
      "totalFar": "Total FAR:",
      "totalFloor": "Total Zòn Etaj Pèmèt:",
      "overlay": {
        "fithDistrict": "Pwojè sa a se nan Senkyèm Distri a kouvri Distri (/VDO).",
        "greenRoof": "Pwojè sa a pral touche yon Bonis Do-Kay Green.",
        "minMixed": "Pwojè sa a se nan/MIN Katye Revni Mixed Overlay. ",
        "todDevelopement": "Pwojè sa a se nan/TOD Transit oryante Devlopman Superposer la.",
      },
      "sFHA": [
        "Espesyal Zòn Danje Inondasyon",
      ],
      "numberOfDwellingUnits": "Nimewo nan inite lojman pèmèt anba dekoupaj an zòn baz:",
      "about": "Osijè de",
      "aboutTitle": "Sou bonis nan lojman revni melanje",
      "aboutSubTitle": "Kouman yo itilize kalkilatris la",
      "paragraphOne": "Bonis nan lojman revni melanje se pou devlopè ki ajoute abitasyon abòdab nan pwojè yo oswa peye nan yon fon ki sipòte lojman abòdab. An retou, devlopman an vin plis “pa-dwa” zòn etaj, wotè, ak/oswa inite rete. Devlopè ka chwazi nan de nivo bonis. Nivo revni modere a se yon bonis ki pi piti, men li gen estanda abòdab mwens strik oswa yon kantite lajan peman pi ba yo. Nivo revni ki ba a se yon bonis pi gwo, men li gen estanda abòdab sevè oswa yon kantite lajan peman ki pi wo.",
      "paragraphTwo": {
        "text": "Se kalkilatris a melanje bonis lojman revni itilize avèk presizyon estime a:",
        "bullets": [
          "Total kantite inite ki pèmèt yo.",
          "Total kantite inite abòdab ke ou pral oblije bay.",
          "Frè nan plas kantite lajan yo dwe peye pou yon devlopman ki sèvi ak bonis nan lojman revni melanje.",
        ],
      },
      "paragraphThree": {
        "text": "Pou kòmanse, chwazi distri dekoupaj an zòn baz pwopriyete a epi antre nan zòn anpil li yo. Ou ta dwe chwazi tou nenpòt distri kouvri ki aplikab yo. Ou ka itilize",
        "link": {
          "text": "Atlas",
          "p": {
            "url": "https://atlas.phila.gov/",
          },
        },
        "continuation": "jwenn enfòmasyon sa a.",
      },
      "finalConfirmation": "Kalkilatris sa a se pou itilize pou planifikasyon pwojè konseptyèl ekspresyon. Ki kote ki gen yon erè ant kalkilatris a ak kòd la Zoning Philadelphia, Kòd la Zonaj Philadelphia dwe gouvène. Konfimasyon final nan inite yo, nimewo yo egzije a inite abòdab, ak/oswa frè nan kantite lajan plas yo pral fèt pa anplwaye Komisyon Planifikasyon Vil Philadelphia pandan revizyon pèmi dekoupaj an zòn. ",
      "resources": "Resous",
      "code1": {
        "link": {
          "text": "Kòd Philadelphia — 14-702 (7) — Bonis Lojman Revni Melanje",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117",
          },
        },
      },
      "code2": {
        "link": {
          "text": "Philadelphia Kòd - 14-533 - Melanje Revni Katye Overlay Distri",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906",
          },
        },
      },
      "facts": {
        "link": {
          "text": "Melanj revni lojman bonis fèy papye",
          "p": {
            "url": "https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/",
          },
        },
      },
    },
};